import { RootState } from "store/store";
import { UserState } from "./types";
import { JoyrideStatus } from "api/joyride/types";

export const selectActiveUserStatus = (store: RootState): UserState['isSignedIn'] => store.userStateSlice.isSignedIn
export const selectActiveUser = (store: RootState): UserState => store.userStateSlice
export const selectJoyrideStatus = (store: RootState): JoyrideStatus => store.userStateSlice.joyrideStatus
